{
  "address": "HH8k3nrckWYLVeAHGoqH1ebatiHdZk4K427JiPvW5UsL",
  "metadata": {
    "name": "cool_program",
    "version": "0.1.0",
    "spec": "0.1.0",
    "description": "Created with Anchor"
  },
  "instructions": [
    {
      "name": "deposit",
      "discriminator": [
        242,
        35,
        198,
        137,
        82,
        225,
        242,
        182
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "mint"
        },
        {
          "name": "user_token_account",
          "writable": true
        },
        {
          "name": "subscription_wallet",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  117,
                  98,
                  115,
                  99,
                  114,
                  105,
                  112,
                  116,
                  105,
                  111,
                  110,
                  95,
                  119,
                  97,
                  108,
                  108,
                  101,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          }
        },
        {
          "name": "subscription_wallet_token_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "mint"
              },
              {
                "kind": "account",
                "path": "subscription_wallet"
              }
            ]
          }
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        }
      ],
      "args": [
        {
          "name": "amount",
          "type": "u64"
        }
      ]
    },
    {
      "name": "initialize_service",
      "discriminator": [
        201,
        217,
        126,
        168,
        40,
        110,
        122,
        89
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "token_account",
          "writable": true
        },
        {
          "name": "service_mint",
          "writable": true,
          "signer": true
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "token_program",
          "address": "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb"
        },
        {
          "name": "rent",
          "address": "SysvarRent111111111111111111111111111111111"
        },
        {
          "name": "nft_authority",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  110,
                  102,
                  116,
                  95,
                  97,
                  117,
                  116,
                  104,
                  111,
                  114,
                  105,
                  116,
                  121
                ]
              },
              {
                "kind": "account",
                "path": "service_mint"
              }
            ]
          }
        },
        {
          "name": "service_tariff_list",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  101,
                  114,
                  118,
                  105,
                  99,
                  101,
                  95,
                  116,
                  97,
                  114,
                  105,
                  102,
                  102,
                  115
                ]
              },
              {
                "kind": "account",
                "path": "service_mint"
              }
            ]
          }
        }
      ],
      "args": [
        {
          "name": "title",
          "type": "string"
        },
        {
          "name": "description",
          "type": "string"
        },
        {
          "name": "logo_link",
          "type": "string"
        },
        {
          "name": "background_link",
          "type": "string"
        }
      ]
    },
    {
      "name": "initialize_subscription_wallet",
      "discriminator": [
        128,
        82,
        48,
        172,
        136,
        141,
        103,
        244
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "subscription_wallet",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  117,
                  98,
                  115,
                  99,
                  114,
                  105,
                  112,
                  116,
                  105,
                  111,
                  110,
                  95,
                  119,
                  97,
                  108,
                  108,
                  101,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          }
        },
        {
          "name": "mint"
        },
        {
          "name": "subscription_wallet_token_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "mint"
              },
              {
                "kind": "account",
                "path": "subscription_wallet"
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "rent",
          "address": "SysvarRent111111111111111111111111111111111"
        }
      ],
      "args": []
    },
    {
      "name": "initialize_tariff",
      "discriminator": [
        28,
        123,
        248,
        249,
        109,
        98,
        228,
        82
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "token_account",
          "writable": true
        },
        {
          "name": "tariff_mint",
          "writable": true,
          "signer": true
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "token_program",
          "address": "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb"
        },
        {
          "name": "rent",
          "address": "SysvarRent111111111111111111111111111111111"
        },
        {
          "name": "nft_authority",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  110,
                  102,
                  116,
                  95,
                  97,
                  117,
                  116,
                  104,
                  111,
                  114,
                  105,
                  116,
                  121
                ]
              },
              {
                "kind": "account",
                "path": "tariff_mint"
              }
            ]
          }
        },
        {
          "name": "service_mint"
        },
        {
          "name": "service_tariff_list",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  101,
                  114,
                  118,
                  105,
                  99,
                  101,
                  95,
                  116,
                  97,
                  114,
                  105,
                  102,
                  102,
                  115
                ]
              },
              {
                "kind": "account",
                "path": "service_mint"
              }
            ]
          }
        },
        {
          "name": "author_subscription_wallet",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  117,
                  98,
                  115,
                  99,
                  114,
                  105,
                  112,
                  116,
                  105,
                  111,
                  110,
                  95,
                  119,
                  97,
                  108,
                  108,
                  101,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          }
        }
      ],
      "args": [
        {
          "name": "title",
          "type": "string"
        },
        {
          "name": "description",
          "type": "string"
        },
        {
          "name": "price",
          "type": "u64"
        },
        {
          "name": "periodicity",
          "type": "u64"
        }
      ]
    },
    {
      "name": "subscribe",
      "discriminator": [
        254,
        28,
        191,
        138,
        156,
        179,
        183,
        53
      ],
      "accounts": [
        {
          "name": "signer",
          "docs": [
            "The user initiating the subscription"
          ],
          "writable": true,
          "signer": true
        },
        {
          "name": "tariff_mint",
          "docs": [
            "The Token-2022 mint account containing the tariff's metadata"
          ]
        },
        {
          "name": "usdc_mint",
          "docs": [
            "The SPL token mint for USDC"
          ]
        },
        {
          "name": "subscription_wallet",
          "docs": [
            "The signer's subscription wallet, derived as a PDA"
          ],
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  117,
                  98,
                  115,
                  99,
                  114,
                  105,
                  112,
                  116,
                  105,
                  111,
                  110,
                  95,
                  119,
                  97,
                  108,
                  108,
                  101,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          }
        },
        {
          "name": "signer_subscription_wallet_token_account",
          "docs": [
            "The USDC token account for the signer's subscription wallet"
          ],
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "usdc_mint"
              },
              {
                "kind": "account",
                "path": "subscription_wallet"
              }
            ]
          }
        },
        {
          "name": "author_subscription_wallet",
          "docs": [
            "The author's subscription wallet, validated against the tariff's metadata"
          ]
        },
        {
          "name": "author_subscription_wallet_token_account",
          "docs": [
            "The USDC token account for the author's subscription wallet"
          ],
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "usdc_mint"
              },
              {
                "kind": "account",
                "path": "author_subscription_wallet"
              }
            ]
          }
        },
        {
          "name": "token_program",
          "docs": [
            "The SPL Token program for handling USDC transfers"
          ],
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        }
      ],
      "args": []
    }
  ],
  "accounts": [
    {
      "name": "NftAuthority",
      "discriminator": [
        194,
        127,
        219,
        16,
        219,
        18,
        250,
        12
      ]
    },
    {
      "name": "ServiceTariffList",
      "discriminator": [
        160,
        106,
        249,
        79,
        227,
        68,
        22,
        54
      ]
    },
    {
      "name": "SubscriptionWallet",
      "discriminator": [
        255,
        81,
        65,
        25,
        250,
        57,
        38,
        118
      ]
    }
  ],
  "errors": [
    {
      "code": 6000,
      "name": "InvalidAmount",
      "msg": "Amount must be greater than zero"
    },
    {
      "code": 6001,
      "name": "InsufficientFunds",
      "msg": "Insufficient funds in user token account"
    },
    {
      "code": 6002,
      "name": "MissingMetadataField",
      "msg": "Missing metadata field in tariff mint"
    },
    {
      "code": 6003,
      "name": "InvalidPubkey",
      "msg": "Invalid public key in metadata"
    },
    {
      "code": 6004,
      "name": "InvalidPrice",
      "msg": "Invalid price in metadata"
    },
    {
      "code": 6005,
      "name": "InvalidMintOwner",
      "msg": "Invalid mint owner"
    },
    {
      "code": 6006,
      "name": "InvalidAuthorWallet",
      "msg": "Invalid author subscription wallet"
    }
  ],
  "types": [
    {
      "name": "NftAuthority",
      "type": {
        "kind": "struct",
        "fields": []
      }
    },
    {
      "name": "ServiceTariffList",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "tariffs",
            "type": {
              "vec": "pubkey"
            }
          }
        ]
      }
    },
    {
      "name": "SubscriptionWallet",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "token_accounts",
            "type": {
              "vec": "pubkey"
            }
          },
          {
            "name": "owner",
            "type": "pubkey"
          },
          {
            "name": "bump",
            "type": "u8"
          }
        ]
      }
    }
  ]
}